import React from 'react';
import { graphql } from 'gatsby';
import Seo from '../components/Seo';
import BlockContent from '@sanity/block-content-to-react';
import styled from 'styled-components';
import FadeTransition from '../components/fadeTransition';

const IndexPage = ({ data }) => {
  // add target=blank for links
  const serializers = {
    marks: {
      link: ({ mark, children }) => {
        const { href } = mark;
        return (
          <a href={href} target='_blank' rel='noopener noreferrer'>
            {children}
          </a>
        );
      },
    },
    types: {
      block: props => {
        if (props.node.style === 'disclaimer') {
          return <p className='disclaimer'>{props.children}</p>;
        } else return BlockContent.defaultSerializers.types.block(props);
      },
    },
  };
  return (
    <>
      <Seo title='FAQ' />
      <FadeTransition>
        <h1>FAQ</h1>
        {data.allSanityFaqCategories.nodes.map(category => (
          <React.Fragment key={category.id}>
            <h2
              style={{
                margin: '40px 0 16px',
                color: '#771b61',
                fontSize: '1.75rem',
              }}>
              {category.title}
            </h2>
            {data.sanityCampaign.faqs.map(
              item =>
                item.category.title === category.title && (
                  <Wrapper key={item._key}>
                    <Question>{item.question}</Question>
                    <BlockContent
                      blocks={item._rawAnswer}
                      serializers={serializers}
                    />
                  </Wrapper>
                )
            )}
          </React.Fragment>
        ))}
        {/* {data.sanityCampaign.faqs.map(item => (
          <Wrapper key={item._id}>
            <Question>{item.question}</Question>
            <BlockContent blocks={item._rawAnswer} serializers={serializers} />
          </Wrapper>
        ))} */}
      </FadeTransition>
    </>
  );
};

export const query = graphql`
  query FAQ {
    sanityCampaign(_id: { eq: "c0b30cde-9c45-489e-aab1-35b714d7c2e1" }) {
      faqs {
        _key
        _rawAnswer
        question
        category {
          title
        }
      }
    }
    allSanityFaqCategories(sort: { order: ASC, fields: _createdAt }) {
      nodes {
        title
        id
      }
    }
  }
`;
const Wrapper = styled.div`
  margin: 8px 0 32px;
  .disclaimer {
    font-size: 0.75rem;
    color: #666d70;
  }
`;
const Question = styled.h3`
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 8px;
`;
export default IndexPage;
